import React, { useState } from 'react';
import { Container, Typography, Box, Button, TextField, Alert, Divider } from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

const C = {
  purple: '#552583',
  gold:   '#FDB927',
  bg:     '#F5F5F5',
  white:  '#ffffff',
  text:   '#1a1a1a',
  soft:   '#4a4a4a',
  muted:  '#7a7a7a',
};

export default function SupprimerCompte() {
  const [email, setEmail] = useState('');
  const [sent, setSent]   = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    if (!email.trim()) return;
    const subject = encodeURIComponent('Demande de suppression de compte Usafiri');
    const body    = encodeURIComponent(
      `Bonjour,\n\nJe souhaite supprimer mon compte Usafiri associé à l'adresse e-mail suivante :\n\n${email}\n\nJe confirme vouloir supprimer définitivement mon compte et toutes les données associées.\n\nCordialement.`
    );
    window.location.href = `mailto:contact@usafiri.yt?subject=${subject}&body=${body}`;
    setSent(true);
  }

  return (
    <Box sx={{ backgroundColor: C.bg, minHeight: '100vh' }}>

      <Box sx={{ backgroundColor: C.purple, py: { xs: 6, md: 8 }, textAlign: 'center' }}>
        <Container maxWidth="md">
          <DeleteForeverIcon sx={{ fontSize: 48, color: C.gold, mb: 2 }} />
          <Typography variant="h3" fontWeight={800} color="#fff" sx={{ fontSize: { xs: '1.8rem', md: '2.4rem' }, mb: 1.5 }}>
            Suppression de compte
          </Typography>
          <Typography sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '1rem' }}>
            Demandez la suppression de votre compte et de vos données personnelles
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="sm" sx={{ py: 6 }}>

        <Box sx={{ backgroundColor: C.white, borderRadius: '16px', border: '1px solid #e8e8e8', p: 4, mb: 3 }}>
          <Typography fontWeight={700} sx={{ color: C.text, mb: 1 }}>
            Ce qui sera supprimé
          </Typography>
          <Typography sx={{ color: C.soft, fontSize: '0.9rem', lineHeight: 1.7 }}>
            En soumettant cette demande, votre compte Usafiri sera définitivement supprimé, ainsi que :
          </Typography>
          <Box component="ul" sx={{ color: C.soft, fontSize: '0.9rem', lineHeight: 2, pl: 2, mt: 1 }}>
            <li>Vos informations personnelles (nom, email, téléphone)</li>
            <li>Votre adresse de livraison enregistrée</li>
            <li>L'historique de vos commandes</li>
            <li>Vos restaurants favoris</li>
          </Box>
          <Typography sx={{ color: C.muted, fontSize: '0.85rem', mt: 1 }}>
            La suppression est définitive et irréversible. Elle sera effectuée dans un délai de 30 jours.
          </Typography>
        </Box>

        {sent ? (
          <Alert severity="success" sx={{ borderRadius: '12px' }}>
            Votre demande a été envoyée. Nous traiterons la suppression de votre compte dans un délai de 30 jours.
          </Alert>
        ) : (
          <Box component="form" onSubmit={handleSubmit} sx={{ backgroundColor: C.white, borderRadius: '16px', border: '1px solid #e8e8e8', p: 4 }}>
            <Typography fontWeight={700} sx={{ color: C.text, mb: 2 }}>
              Votre adresse e-mail
            </Typography>
            <TextField
              fullWidth
              type="email"
              placeholder="adresse@email.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              sx={{ mb: 3 }}
              size="small"
            />
            <Divider sx={{ mb: 3 }} />
            <Typography sx={{ color: C.muted, fontSize: '0.85rem', mb: 3 }}>
              En cliquant sur le bouton ci-dessous, votre client e-mail s'ouvrira avec un message pré-rempli à envoyer à notre équipe.
            </Typography>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                backgroundColor: '#D32F2F',
                color: '#fff',
                borderRadius: '10px',
                textTransform: 'none',
                fontWeight: 700,
                py: 1.5,
                '&:hover': { backgroundColor: '#B71C1C' },
              }}
            >
              Demander la suppression de mon compte
            </Button>
          </Box>
        )}

        <Typography sx={{ color: C.muted, fontSize: '0.8rem', textAlign: 'center', mt: 4 }}>
          Pour toute question : contact@usafiri.yt
        </Typography>

      </Container>
    </Box>
  );
}
